@if (showYear || showMonth) {
<div class="tenure-display"
>@if (showYear) {<span class="year-count">{{ yearCount }}</span>yrs}@if (showSpace) {{{ " " }}}@if (showMonth) {<span class="month-count">{{ monthCount }}</span>mos}</div>
} @else {
<div class="tenure-display">-</div>
}
